import React from 'react';
import { Fab } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {
  useVirtuosoLocation,
  useVirtuosoMethods,
} from '@virtuoso.dev/message-list';

export default function CustomChatStickyFooter() {
  const location = useVirtuosoLocation();
  const virtuosoMethods = useVirtuosoMethods();
  return (
    <div
      style={{
        position: 'absolute',
        bottom: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // ensure container doesn't capture pointer events except the fab
        pointerEvents: 'none',
      }}
    >
      {location.bottomOffset > 200 && (
        <div style={{ pointerEvents: 'auto' }}>
          <Fab
            size="small"
            color="secondary"
            onClick={() => {
              virtuosoMethods.scrollToItem({ index: 'LAST', align: 'end', behavior: 'auto' });
            }}
            aria-label="scroll to bottom"
          >
            <KeyboardArrowDownIcon />
          </Fab>
        </div>
      )}
    </div>
  );
}
